import { useEffect, useRef } from "react";

// Same as useEffect, but triggers only once in development mode.
export function useEffectOnce(cb: () => void, dependencies?: unknown[]) {
  const hasMounted = useRef(false);
  const initialDependencies = useRef(dependencies);

  // Dependencies are dynamic by design; cb is intentionally omitted

  useEffect(() => {
    if (hasMounted.current) {
      // Check if dependencies have changed
      const initial = initialDependencies.current;
      const dependenciesChanged =
        initial !== undefined &&
        dependencies?.some((dep, index) => dep !== initial[index]);
      if (dependenciesChanged === true) {
        cb();
        initialDependencies.current = dependencies;
      }
    } else {
      cb();
      hasMounted.current = true;
    }
  }, dependencies);
}
